module.exports = __webpack_public_path__ + "img/titlezh.6b6dea48.png";